import React from 'react'
import VisibilitySensor from "react-visibility-sensor"
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import './progressbar.css'

export function SkillBox(props){
    return (
        <div className="col-md-4 col-sm-6 skills-box-1">
            <div className="skills-content-1">
            
                <div className="bg-white skills-cricle">
                    <VisibilitySensor>
                        {({ isVisible }) => {
                        const percentage = isVisible ? props.skillValue : 0;
                        return (
                            <CircularProgressbar
                                value={percentage}
                                text={`${percentage}%`}
                                width="20"
                                strokeWidth={8}
                                styles={buildStyles({
                                backgroundColor: "#eeeeee",
                                textColor: "#c70039",
                                pathColor: "#c70039",
                                trailColor: "#eeeeee"
                                })}
                            />
                            
                        );
                        }}
                    </VisibilitySensor>
                </div>
                <div className="skills-title">
                    <h4>{props.skillTitle}</h4>
                </div>
            </div>
        </div>
    )
    
}